<div class="custom-mat-dialog-form">
    <div>
        <h3>Assign Protocols</h3>
    </div>
    <div class="custom_small_panelbody_fix add-wave-table">

        <table mat-table
               [dataSource]="dataSource"
               multiTemplateDataRows
               matSort
               class="mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="selector">
                <th mat-header-cell *matHeaderCellDef>  </th>
                <td mat-cell *matCellDef="let selector">
                    <div class="defCheckbox">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="protocolItemsSelected($event.checked,selector);">
                        </mat-checkbox>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef> Protocol Code </th>
                <td mat-cell *matCellDef="let protocol">
                    <p [innerHTML]="protocol.code"></p>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Protocol Name </th>
                <td mat-cell *matCellDef="let protocol">
                    <p [innerHTML]="protocol.name"></p>
                </td>
            </ng-container>

            <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let protocol; let i = dataIndex; columns: columnsToDisplay;"
                class="item">
            </tr>

        </table>

    </div>

    <div class="panel-body">

        <button (click)="backButtonHandler($event)" mat-raised-button class="btn  button-color-fix_red ">
            <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
            Back
        </button>
        <button mat-raised-button type="submit" [disabled]="selectedList.length == 0" (click)="addButtonHandler()" class="btn button-color-fix pull-right ">
            Save
            <mat-icon class="icon-color-fix">save</mat-icon>
        </button>

    </div>
</div>

